// extracted by mini-css-extract-plugin
export default {"chamProjects":"ChamProjects_chamProjects__-TTYG"};